export const isObserverSubdomain = () => window.guardian.isObserverSubdomain;
